import { UserActions, UserActionTypes } from './UserActions';
import { User } from '../../model/User';

export interface UserState {
  user: User;
  isAuthenticated: boolean;
  selectedAccount: string;
  csrfToken: string | null;
  csrfParameterName: string | null;
}

export const initialState: UserState = {
  user: null,
  isAuthenticated: false,
  selectedAccount: null,
  csrfToken: null,
  csrfParameterName: null,
};

export const userReducer = (
  state: UserState = initialState,
  action: UserActions,
) => {
  switch (action.type) {
    case UserActionTypes.InitUser: {
      return {
        ...state,
        user: action.payload,
        selectedAccount: action.selectedAccount,
        isAuthenticated: true,
      };
    }
    case UserActionTypes.SelectAccount: {
      return {
        ...state,
        selectedAccount: action.payload,
      };
    }
    case UserActionTypes.DeSelectAccount: {
      return {
        ...state,
        selectedAccount: null,
      };
    }
    case UserActionTypes.Logout: {
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        selectedAccount: null,
        csrfToken: null,
        csrfParameterName: null,
      };
    }
    case UserActionTypes.SetCsrfToken: {
      return {
        ...state,
        csrfToken: action.token,
        csrfParameterName: action.parameterName,
      };
    }
    case UserActionTypes.ClearCsrfToken: {
      return {
        ...state,
        csrfToken: null,
        csrfParameterName: null,
      };
    }
    case UserActionTypes.HydrateState: {
      return {
        user: action.user,
        isAuthenticated: action.isAuthenticated,
        selectedAccount: action.selectedAccount,
        csrfToken: action.csrfToken,
        csrfParameterName: action.csrfParameterName,
      };
    }
    // There are actions that are undefined and are not
    // handled by the switch-case. To avoid undefined
    // state we must return an unchanged state by default.
    default:
      return state;
  }
};

export const initUser = (state: UserState) => state.user;
export const initIsAuthenticated = (state: UserState) => state.isAuthenticated;
export const initSelectedAccount = (state: UserState) => state.selectedAccount;
export const initCsrfToken = (state: UserState) => state.csrfToken;
export const initCsrfParameterName = (state: UserState) =>
  state.csrfParameterName;
